import { MediaApi } from '../../../api/contentLibrary/models/content-library-media.api.model';


export class FileUploadModel implements MediaApi {
    id?: string;
    name?: string;
    size?: number;
    type?: string;
    url?: string;
    file?: File;
    mimeType?: string;
    altText?: string;
    errorMessage?: string;
    hasError?: boolean;
    touched?: boolean;
    showAltText?: boolean;
    noThumbnail?: boolean;
}

// TODO: Determine if needed
/* const imageFileExtentions = [
    '.jpg',
    '.jpeg',
    '.gif',
    '.png',
    '.bmp',
    '.svg',
];

const officeFileExtensions = [
    '.xls',
    '.xlx',
    '.docx',
    '.csv',
    '.doc',
    '.ppt',
    '.pptx',
    '.rtf',
    '.odp',
    '.odt',
    '.ods',
    '.txt'
];

const csvFileTypes = [
    '.csv'
];

const audioFileExtensions = [
    '.mp3'
];
*/

const imageMIMETypes = [
    'image/*'
];

const officeMIMETypes = [
    'text/csv$',
    'text/plain$',
    'text/comma-separated-values$',
    'application/octet-stream$',
    'application/vnd.ms-excel$',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet$',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation$',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document$',
    'application/msword$',
    'application/vnd.ms-powerpoint$',
    'application/vnd.oasis.opendocument.presentation$',
    'application/vnd.oasis.opendocument.spreadsheet$',
    'application/vnd.oasis.opendocument.text$',
    'application/pdf$',
];

const csvMIMETypes = [
    'text/csv$',
    'text/plain$',
    'text/comma-separated-values$',
    'application/octet-stream$',
    'application/vnd.ms-excel$',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet$'
];

const csvImportMIMETypes = [
    'text/csv$',
    'text/x-csv$',
    'text/comma-separated-values$',
    'text/x-comma-separated-values$',
    'application/vnd.ms-excel$'
];

const xmlMIMETypes = [
    'application/xml$',
    'text/xml$'
];

const htmlMIMETypes = [
    'text/html$'
];

const audioMIMETypes = [
    'audio/mpeg$'
];

const jsonMIMETypes = [
    'application/json$'
];

export const allowedFileTypes = {
    // TODO: Determine if needed
    /* imageFileExtensions: imageFileExtentions,
        officeFileExtensions: officeFileExtensions,
        csvFileTypes: csvFileTypes,
        audioFileExtensions: audioFileExtensions,
        allFileExtensions: [
            ...imageFileExtentions,
            ...officeFileExtensions,
            ...csvFileTypes,
            ...audioFileExtensions
        ],
    */

    imageMIMETypesRegex: imageMIMETypes.join('|'),
    officeMIMETypesRegex: officeMIMETypes.join('|'),
    csvMIMETypesRegex: csvMIMETypes.join('|'),
    csvImportMIMETypesRegex: csvImportMIMETypes.join('|'),
    xmlMIMETypesRegex: xmlMIMETypes.join('|'),
    htmlMIMETypesRegex: htmlMIMETypes.join('|'),
    audioMIMETypesRegex: audioMIMETypes.join('|'),
    jsonMIMETypesRegex: jsonMIMETypes.join('|'),
    allMIMETypesRegex: [
        ...imageMIMETypes,
        ...officeMIMETypes,
        ...csvMIMETypes,
        ...htmlMIMETypes,
        ...audioMIMETypes,
        ...jsonMIMETypes
    ].join('|')
};
